const rangeOfStatusForCalculate = {
  excellent: 1.5,
  good: 1,
  fair: 0.5,
  poor: 0,
};

export { rangeOfStatusForCalculate as RangeOfStatusForCalculate };
